import React from 'react';
import { gql } from '@ts-gql/tag';
import { useMutation } from '@ts-gql/apollo';

const mutation = gql`
  mutation DeleteTask($cloudId: String!) {
    deleteTask(input: { cloudId: $cloudId }) {
      correlationId
      validationMessage {
        field
        message
      }
      messagesSuccessfullyProcessed
    }
  }
` as import('../../__generated__/ts-gql/DeleteTask').type;

export const useDeleteTask = () => {
  const tuple = useMutation(mutation);

  const [_mutate, result] = tuple;

  const mutate = React.useCallback<typeof _mutate>(
    (options) => {
      if (!options.variables.cloudId) {
        throw new Error('variable "cloudId" is required in useDeleteTask');
      }
      return _mutate({
        context: { service: 'core' },
        update(cache) {
          const { cloudId } = options.variables;
          const id = cache.identify({ __typename: 'Task', cloudId });
          cache.evict({ id });
        },
        ...options,
      });
    },
    [_mutate]
  );

  return React.useMemo<typeof tuple>(() => [mutate, result], [mutate, result]);
};
